export const SESSION_DRAWER_STATUS = {
	IDLE: 'idle',
	LOADING: 'loading',
	READY: 'ready',
	ERROR: 'error',
}

export const SUMMARY_MODE = {
	VIEW: 'view',
	EDIT: 'edit',
}

export const TRANSCRIPT_DRAWER_STATUS = {
	CLOSED: 'closed',
	LOADING: 'loading',
	READY: 'ready',
	ERROR: 'error',
}

export const ACTION_ITEM_DEBOUNCE_MS = 800
